module.exports = __webpack_public_path__ + "static/img/shcygn4.bffddae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn4.png
// module id = 374
// module chunks = 0